import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import type { AxiosError, AxiosResponse } from 'axios'
import axios from 'axios'

import { localStorageService } from '@/service/storage.service'
import type { PrintError } from '@/types/common/api'
import { envUtils } from '@/utils/envUtils'
import { _mixpanelUtils } from '@/utils/trackings/_mixpanel'

import { wrapErrorHandlerWithJwt, wrapRequestInterceptorWithJwt } from './jwtInterceptors'

// 로컬에서 인쇄 에이전트 서버를 바꿔 붙일 수 있어(localStorage 'print-api') 주소를 요청마다 정한다
const printBaseURL = () => {
  const localPrintApi = localStorageService.getItem('print-api')
  if (localPrintApi) {
    return localPrintApi
  }
  if (envUtils.isStaging || localStorage.getItem('DEV_API') === 'stg') {
    return `https://print-staging.${domainProvider.TARGET_DOMAIN}/v1.0`
  }
  if (envUtils.isLive) {
    return `https://print.${domainProvider.TARGET_DOMAIN}/v1.0`
  }
  return `https://print-dev.${domainProvider.TARGET_DOMAIN}/v1.0`
}

export const printAxios = axios.create()

printAxios.interceptors.request.use(
  wrapRequestInterceptorWithJwt((config) => {
    config.baseURL = printBaseURL()
    return config
  }),
)

printAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    _mixpanelUtils.printApiTrack(response)
    return response
  },
  wrapErrorHandlerWithJwt(
    async (error: unknown) => {
      const axiosError = error as AxiosError<PrintError>
      _mixpanelUtils.printErrorTrack(axiosError)
      return Promise.reject(axiosError)
    },
    async (originalRequest, newAccessToken) => {
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
      return printAxios(originalRequest)
    },
  ),
)
